export default {
  email: '',
  password: '',
};